import { render, staticRenderFns } from "./adviceModal.vue?vue&type=template&id=6fd7e5ed&scoped=true&"
import script from "./adviceModal.vue?vue&type=script&lang=js&"
export * from "./adviceModal.vue?vue&type=script&lang=js&"
import style0 from "./adviceModal.vue?vue&type=style&index=0&id=6fd7e5ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd7e5ed",
  null
  
)

export default component.exports